export default __webpack_public_path__ + "static/media/template11.4a0b8743.png";